import '@Components/ScenarioPlanningChart/ScenarioPlanningChart.scss';
import * as R from 'ramda';
import { ReactElement } from 'react';
import { LabelProps } from 'recharts';
import { Brand100 } from '../../utils/colors';

const LABEL_WIDTH = 80;
const LABEL_HEIGHT = 26;

interface ScenarioPlanningBarLabelProps extends Omit<LabelProps, 'formatter'> {
  isRmmm?: boolean;
  formatter?: (value: number | string) => string | number;
}

export const ScenarioPlanningBarLabel = (
  props: ScenarioPlanningBarLabelProps
): ReactElement | null => {
  const { formatter, isRmmm, value, width, x, y } = props;
  if (R.isNil(value)) {
    return null;
  }
  const numericX = typeof x === 'number' ? x : 0;
  const numericY = typeof y === 'number' ? y : 0;
  const numericWidth = typeof width === 'number' ? width : 0;
  const xPos = numericX + numericWidth / 2 - LABEL_WIDTH / 2;
  const yPos = numericY - 30;
  return (
    <foreignObject height={LABEL_HEIGHT} width={LABEL_WIDTH} x={xPos} y={yPos}>
      <div className='scenario-planning-bar-label-wrapper'>
        <div
          className={`scenario-planning-bar-label${isRmmm ? ' shadow-sm' : ''}`}
          style={{
            background: isRmmm ? undefined : 'transparent',
            borderColor: isRmmm ? Brand100 : 'transparent',
            color: Brand100
          }}
        >
          {formatter ? formatter(value as number | string) : value}
        </div>
      </div>
    </foreignObject>
  );
};
